import React from "react";

export default function Layout({ children }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        height: "100%",
        backgroundPosition: "fixed",
        background: "linear-gradient(to right bottom, #0a3526, #688a7e)",
        paddingTop: "50px",
        paddingBottom: "50px",
      }}
    >
      {children}
    </div>
  );
}
